import { State } from 'src/replicant/State';
import { Pet } from 'src/replicant/buruburu/pet';
import { PetState } from './pet.redux';
import StateObserver from 'src/StateObserver';

export function syncPetState(initialState: PetState, user: State): PetState {
  const now = StateObserver.now();
  const {
    getAllStatusEffects,
    getAllAttributeValues,
    getPetAge,
    getCurrentEvolution,
  } = Pet.getters(user);

  const petState = { ...initialState };
  petState.species = getCurrentEvolution()?.species;
  petState.statusEffects = getAllStatusEffects(now);
  petState.attributes = Object.assign(
    { ...petState.attributes },
    {
      name: user.pet.name,
      age: getPetAge(now),
      ...getAllAttributeValues(now),
    },
  );

  return petState;
}
